/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger } = createLoggerInterface()
